export default __webpack_public_path__ + "static/media/toolbar-active.fb12116b.svg";